// extracted by mini-css-extract-plugin
module.exports = {"historyBody":"history_historyBody__2j6ha","historyContainer":"history_historyContainer__zbEDW","timeline":"history_timeline__2RYIl"};